import { referralRepository } from '@infra/supabase/repositories/SupabaseReferralRepository';

export const createPipelineReferralLink = referralRepository.createLink;
export const lookupPipelineReferral = referralRepository.lookup;
export const submitPipelineReferral = referralRepository.submit;
export type { ReferralLink, ReferralLookup, ReferralPayload } from '@infra/supabase/repositories/SupabaseReferralRepository';
